import { useAssemblyInfoFromAssemblyId } from '@/state';
import { AllHistoriesQuery } from '@/__generated__/graphql';
import { formatDate, formatName } from '@/utils';

type PartsAddedToAssemblyEntryProps = {
  history: AllHistoriesQuery['allHistories'][0];
};

export const PartsAddedToAssemblyEntry = ({ history }: PartsAddedToAssemblyEntryProps) => {
  const assembly = useAssemblyInfoFromAssemblyId(history.document.assemblyId);
  return (
    <p>
      <b>Tagged {assembly?.tagName}</b>
      <br />
      {formatName(history.createdByName)} - {formatDate(new Date(Number(history.createdAt)))}
    </p>
  );
};
